// W2Cook Billing Dashboard — Login screen

import { useState } from "react";
import { signIn } from "../auth/firebase";
import { tokens as T } from "../theme/tokens";

const LOGO = "/dhivins-labs-logo.png";

export function LoginScreen() {
  const [email,    setEmail   ] = useState("");
  const [password, setPassword] = useState("");
  const [error,    setError   ] = useState("");
  const [loading,  setLoading ] = useState(false);
  const [showPass, setShowPass] = useState(false);

  const handleSubmit = async () => {
    if (!email || !password) { setError("Email and password are required."); return; }
    setLoading(true);
    setError("");
    try {
      await signIn(email, password);
    } catch (e: any) {
      const msg = e?.message ?? "Sign-in failed.";
      if (msg.includes("user-not-found") || msg.includes("wrong-password") || msg.includes("invalid-credential")) {
        setError("Invalid email or password.");
      } else if (msg.includes("too-many-requests")) {
        setError("Too many attempts. Please try again later.");
      } else {
        setError(msg);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: "100vh", background: T.bg,
      display: "flex", alignItems: "center", justifyContent: "center",
      fontFamily: "'DM Sans', system-ui, sans-serif", padding: 20,
    }}>
      <div style={{ width: "100%", maxWidth: 380 }}>

        {/* Logo */}
        <div style={{ textAlign: "center", marginBottom: 36 }}>
          <div style={{
            display: "inline-block",
            background: "#0D2B1F",  // matches logo's dark green bg
            borderRadius: 16,
            padding: "16px 28px",
            marginBottom: 20,
          }}>
            <img
              src={LOGO}
              alt="Dhivins Labs"
              style={{ height: 56, width: "auto", objectFit: "contain", display: "block" }}
            />
          </div>
          <div style={{ fontSize: 13, color: T.textDim, letterSpacing: "0.08em" }}>
            BILLING DASHBOARD
          </div>
        </div>

        {/* Card */}
        <div style={{
          background: T.surface, border: `1px solid ${T.border}`,
          borderRadius: 14, padding: 28,
        }}>
          <div style={{ fontSize: 16, fontWeight: 600, color: T.text, marginBottom: 6 }}>
            Sign in
          </div>
          <div style={{ fontSize: 13, color: T.textMuted, marginBottom: 24 }}>
            Restricted to @w2cook.com and @dhivinslabs.com accounts.
          </div>

          {/* Email */}
          <div style={{ marginBottom: 14 }}>
            <div style={{ fontSize: 11, color: T.textMuted, letterSpacing: "0.08em", marginBottom: 5 }}>EMAIL</div>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              onKeyDown={e => e.key === "Enter" && handleSubmit()}
              placeholder="you@dhivinslabs.com"
              autoComplete="email"
              style={{
                width: "100%", boxSizing: "border-box",
                background: T.bg, border: `1px solid ${T.border}`,
                borderRadius: 8, color: T.text, padding: "10px 12px",
                fontSize: 14, outline: "none", fontFamily: "inherit",
              }}
            />
          </div>

          {/* Password */}
          <div style={{ marginBottom: 20 }}>
            <div style={{ fontSize: 11, color: T.textMuted, letterSpacing: "0.08em", marginBottom: 5 }}>PASSWORD</div>
            <div style={{ position: "relative" }}>
              <input
                type={showPass ? "text" : "password"}
                value={password}
                onChange={e => setPassword(e.target.value)}
                onKeyDown={e => e.key === "Enter" && handleSubmit()}
                placeholder="••••••••"
                autoComplete="current-password"
                style={{
                  width: "100%", boxSizing: "border-box",
                  background: T.bg, border: `1px solid ${T.border}`,
                  borderRadius: 8, color: T.text, padding: "10px 36px 10px 12px",
                  fontSize: 14, outline: "none", fontFamily: "inherit",
                }}
              />
              <button
                onClick={() => setShowPass(p => !p)}
                style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", color: T.textDim, cursor: "pointer", fontSize: 14 }}
              >{showPass ? "🙈" : "👁"}</button>
            </div>
          </div>

          {/* Error */}
          {error && (
            <div style={{
              padding: "10px 14px", borderRadius: 8, marginBottom: 16,
              background: `${T.ember}15`, border: `1px solid ${T.ember}40`,
              color: T.ember, fontSize: 13,
            }}>❌ {error}</div>
          )}

          {/* Submit */}
          <button
            onClick={handleSubmit}
            disabled={loading}
            style={{
              width: "100%", padding: "11px 0",
              background: loading ? T.surfaceAlt : T.ember,
              border: "none", borderRadius: 8,
              color: "#fff", fontSize: 14, fontWeight: 600,
              cursor: loading ? "not-allowed" : "pointer",
              fontFamily: "inherit", transition: "background 0.15s",
            }}
          >{loading ? "Signing in…" : "Sign in"}</button>
        </div>

        <div style={{ textAlign: "center", marginTop: 20, fontSize: 12, color: T.textDim }}>
          Need access? Contact your Dhivins Labs admin.
        </div>
      </div>
    </div>
  );
}
